import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import { observer } from 'mobx-react';
import AmenityList from '@molecules/AmenitiesList/AmenitiesList';
import { Amenity } from '@data/types/common';
import { useTranslation } from 'react-i18next';

type ModalAmenitiesProps = {
  amenities: Array<Amenity>;
  additionalAmenities?: Array<Amenity>;
} & ModalProps;

const ModalAmenities = ({
  amenities,
  additionalAmenities,
  ...modalProps
}: ModalAmenitiesProps) => {
  const { t } = useTranslation();

  return (
    <ModalComponent {...modalProps} title={t('amenities')}>
      <AmenityList
        amenities={amenities}
        additionalAmenities={additionalAmenities}
        type="category"
      />
    </ModalComponent>
  );
};

export default observer(ModalAmenities);
